/* import __COLOCATED_TEMPLATE__ from './new-selector-item.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();